<template>
  <div v-if="useWrapper" :class="`form-ant-switch-wrapper${wrapperClass ? ` ${wrapperClass}` : ''}`" data-type="switch">
    <a-switch v-bind="$attrs" :checked="_value" @update:checked="returnValue" />
  </div>
  <a-switch v-else v-bind="$attrs" :checked="_value" @update:checked="returnValue" />
</template>

<script>
export default {
  name: 'FormAntdToggle',
  inheritAttrs: false,
  components: {},
  props: {
    /**
     * Value bound via v-model.
     */
    modelValue: {
      type: [String, Number, Boolean],
      default: ''
    },
    /**
     * Use Wrapper.
     */
    useWrapper: {
      type: Boolean,
      default: false
    },
    /**
     * Additional classes for the wrapper.
     */
    wrapperClass: {
      type: String,
      default: ''
    }
  },
  emits: ['update:modelValue'],
  computed: {
    _value: {
      get() {
        return this.modelValue
      },
      set(value) {
        this.returnValue(value)
      }
    }
  },
  methods: {
    returnValue(value) {
      // emit updateModel value
      this.$emit('update:modelValue', value)
      if (this.$attrs.onUpdateModelValue && typeof this.$attrs.onUpdateModelValue === 'function') {
        this.$attrs.onUpdateModelValue(value)
      }
    }
  }
}
</script>

<style lang="postcss" scoped></style>
